<template>
    <div class="workouts-index"> 
         <v-tabs centered background-color="transparent">
                <v-tab @click="$inertia.visit('/backoffice/exercises')">Exercises</v-tab>
                <v-tab @click="$inertia.visit('/backoffice/workouts')">Workouts</v-tab>
                <v-tab @click="$inertia.visit('/backoffice/programs')">Programs</v-tab>
            </v-tabs>
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Workouts" }}</h2>
            </div>
            <div class="right">
                <new-workout></new-workout>
            </div>
        </div>
        <div>
        </div>
        <div class="page-body">
            <v-data-table
            :headers="tableHeaders"
            :items="workouts.data"
            :server-items-length="workouts.total"
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
            item-key="id"
            :page="workouts.current_page"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            mobile-breakpoint="0"
            :footer-props="{
                    'items-per-page-options': [5, 10, 25, 50]
                }"
            >
                <template v-slot:item.thumbnail="{ item }">
                    <inertia-link :href="'/backoffice/workouts/edit/'+item.id" class="name">
                        <v-avatar size="40">
                            <!-- <img :src="item.profile_photo_url + '?w=80'" alt=""> -->
                        </v-avatar>
                    </inertia-link>
                </template>
                <template v-slot:item.name="{ item }">
                     <inertia-link :href="'/backoffice/workouts/edit/'+item.id">
                    {{ item.name }}<br>
                    0 vezbi
                     </inertia-link>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn @click="remove(item)"  color="red" :id="'delete' + item.id"  icon>
                        <v-icon>mdi-delete</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.deletePayment || "Delete"}}</span>
                        </v-tooltip>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import ExerciseModal from '@/js/Pages/Backoffice/Workouts/Components/Exercises'
import NewWorkout from '@/js/Pages/Backoffice/Workouts/Components/NewWorkout'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Workouts"
        }
    },
    components: {
        ExerciseModal,
        NewWorkout
    },
    layout: AppLayout,
    props:{
        workouts: Object,
        lang: Object     
    },
    data(){
        return{
            tableHeaders: [
                {text: '', value: 'thumbnail', align: 'center', sortable: false},
                {text: this.lang.name || 'Name', value: 'name', align: 'start', sortable: true},
                {text: '', value: 'actions', align: 'end', sortable: false}
            ],
            options:{
                page: this.workouts.current_page, 
                itemsPerPage: this.workouts.per_page
            },
            page: null,
            sortBy: [],
            sortDesc: [],
        }
    },
    created() {
        this.initPageAndSort()
    },
    watch: {
    options:{
             
             handler (val, oldVal) {
                
                if(val.page != oldVal.page || val.sortBy != oldVal.sortBy || val.sortDesc != oldVal.sortDesc || val.itemsPerPage != oldVal.itemsPerPage){

                    let data = {}
                    let order = this.options.sortDesc[0]===false ? 'asc' : 'desc';

                    if (this.options.sortDesc.length>0 & oldVal.sortDesc != val.sortDesc) { 
                        data.order = order
                        data.sort = this.options.sortBy[0]
                        data.page = oldVal.page
                        
                    }else{
                        data.page = val.page;
                    }
                  
                    let obj = this.form;
                    
                    if (this.form.search!==null) { data.search = this.form.search}
                    data.items_per_page = this.options.itemsPerPage;
              
                    let finalData = Object.assign(data, obj);
                   
                    this.$inertia.get('/backoffice/workouts', pickBy(finalData), {preserveState: true});
                    this.options.page = this.workouts.current_page;
                }
              
            }
    },
            deep: true,
        },
    methods:{
        initPageAndSort() {
            let pageUrl = new URLSearchParams(window.location.search)
            let sortDesc = pageUrl.get('order')
            let sortBy = pageUrl.get('sort')
            let page = pageUrl.get('page')
            this.page = page ? page : null
           
            sortBy ? this.sortBy[0] = sortBy : ''
            if (sortDesc) {
                sortDesc==='asc' ? this.sortDesc[0] = false : this.sortDesc[0] = true
            }
        },

    }
}

</script>